import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { downloadBlob } from 'receipts';
import { NewCustomerService } from '../../../services/new-customer.service';
import { NewCustomerBanner } from '../new-customer-banner/new-customer-banner';
import { NewCustomerPreparing } from '../new-customer-preparing/new-customer-preparing';
import { NewCustomerUpload } from '../new-customer-upload/new-customer-upload';

// Consenso GDPR firmato: si può caricare anche dopo, la richiesta parte comunque.
// Per le società di capitali il modulo si scarica ma non c'è un consenso da caricare
@Component({
  selector: 'ord-new-customer-gdpr',
  imports: [MatButtonModule, NewCustomerBanner, NewCustomerPreparing, NewCustomerUpload],
  templateUrl: './new-customer-gdpr.html',
  styleUrl: './new-customer-gdpr.scss',
})
export class NewCustomerGdpr {
  readonly flow = inject(NewCustomerService);
  private readonly snackBar = inject(MatSnackBar);

  readonly consensi = this.flow.consensiGdpr;
  readonly busy = computed(() => this.flow.creating() || this.flow.downloading());
  readonly canContinue = computed(() => !this.busy() && (!this.consensi() || this.flow.gdprDocuments().length > 0));

  download(): void {
    if (this.busy()) {
      return;
    }

    this.flow.downloadGdprTemplate().subscribe({
      next: ({ blob, fileName }) => {
        downloadBlob(blob, fileName);
        this.snackBar.open('Template GDPR scaricato con successo.', 'Chiudi', { duration: 5000 });
      },
      error: (error: unknown) => this.showError(error),
    });
  }

  // La richiesta parte con o senza il consenso: la proposta risponde col cliente provvisorio
  create(skipGdpr: boolean): void {
    if (this.busy()) {
      return;
    }

    this.flow.create(skipGdpr).subscribe({
      next: proposal => this.flow.result.set({ proposalId: proposal.id }),
      error: (error: unknown) => this.showError(error),
    });
  }

  private showError(error: unknown): void {
    const message = this.flow.errorMessage(error);
    if (message) {
      this.snackBar.open(message, 'Chiudi', { duration: 5000 });
    }
  }
}
